import React from "react";
import BackgroundTitle from "../../components/ui/BackgroundTitle";
import { Link } from "react-router-dom";

function Contact() {
  return (
    <>
      <div>
        <BackgroundTitle title='CONTACT US' />
      </div>
      <div className='px-5 sm:px-7 lg:px-14 xl:px-48 py-28'>
        <div className='text-black/75'>
          <h1 className='text-3xl pb-8'>Contact Information</h1>
          <div className='grid grid-cols-1 sm:grid-cols-4 gap-5'>
            <div className='text-gray-400 flex gap-1'>
              <div>
                <h1>Address:</h1>
              </div>
              <div>
                <p>198 West 21th Street, Suite 721 New York NY 10016</p>
              </div>
            </div>
            <div className='flex gap-1'>
              <div>
                <h1 className='text-gray-400'>Phone:</h1>
              </div>
              <div>
                <a
                  href='tel:+ 1235 2355 98'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  + 1235 2355 98
                </a>
              </div>
            </div>
            <div className='flex gap-1'>
              <div>
                <h1 className='text-gray-400'>Email:</h1>
              </div>
              <div>
                <a
                  href='mailto:info@yoursite.com'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  info@yoursite.com
                </a>
              </div>
            </div>
            <div className='flex gap-1'>
              <div>
                <h1 className='text-gray-400'>Website:</h1>
              </div>
              <div>
                <Link to='/'>yoursite.com</Link>
              </div>
            </div>
          </div>
        </div>
        <div className='grid grid-cols-1 sm:grid-cols-2 gap-14 mt-14'>
          <div className=''>
            <form action=''>
              <div className='mb-4'>
                <input
                  className='outline-none border w-full focus:border-black rounded-sm p-3.5'
                  placeholder='Your Name'
                  type='text'
                  name=''
                  id=''
                />
              </div>
              <div className='mb-4'>
                <input
                  className='outline-none border w-full focus:border-black rounded-sm p-3.5'
                  placeholder='Your Email'
                  type='email'
                  name=''
                  id=''
                />
              </div>
              <div className='mb-4'>
                <input
                  className='outline-none border w-full focus:border-black rounded-sm p-3.5'
                  placeholder='Subject'
                  type='text'
                  name=''
                  id=''
                />
              </div>
              <div className='mb-4'>
                <textarea
                  className='outline-none border w-full focus:border-black rounded-sm p-3.5'
                  name=''
                  id=''
                  cols='20'
                  rows='6'
                  placeholder='Message'
                ></textarea>
              </div>
              <div className='mb-4'>
                <button className='bg-primary hover:bg-transparent border border-primary hover:text-primary p-3.5 px-10 rounded-full text-white font-sans text-md hover:cursor-pointer'>
                  Send Message
                </button>
              </div>
            </form>
          </div>
          <div>
            <iframe
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14416.631591187046!2d82.38219030334372!3d25.399524691296865!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398fe3346af4439d%3A0x6dd7acba67338123!2sAsaipur%2C%20Uttar%20Pradesh%20221404!5e0!3m2!1sen!2sin!4v1703768288756!5m2!1sen!2sin'
              className='border-none w-full h-96 sm:h-[90%]'
              title='Map'
              allowFullScreen=''
              loading='lazy'
              referrerPolicy='no-referrer-when-downgrade'
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
